import { render, staticRenderFns } from "./IndexValueDetails.vue?vue&type=template&id=c5eadbec&scoped=true&"
import script from "./IndexValueDetails.vue?vue&type=script&lang=js&"
export * from "./IndexValueDetails.vue?vue&type=script&lang=js&"
import style0 from "./IndexValueDetails.vue?vue&type=style&index=0&id=c5eadbec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5eadbec",
  null
  
)

export default component.exports